import {formatISO, lastDayOfMonth, setDate, sub} from "date-fns";
import type {Dispatch} from "redux";

import type {IFetchContext} from "@pg-mono/data-fetcher";
import {createRequestActionTypes} from "@pg-mono/request-state";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRPRequestMeta} from "../../../app/rp_request_meta";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";
import type {IAveragePricesQuery} from "../types/IAveragePricesQuery";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";
import {fetchAveragePricesBySlug} from "./fetch_average_prices";

const FETCH_REPORT_PRICE_ALL_CITIES_PRICES_HISTORY = "reports/FETCH_REPORT_PRICE_ALL_CITIES_PRICES_HISTORY";

export const fetchReportPriceAllCitiesPricesHistoryTypes = createRequestActionTypes(FETCH_REPORT_PRICE_ALL_CITIES_PRICES_HISTORY);

/** The oldest month the offer-price endpoint serves is 12 months before the newest complete one. */
const HISTORY_MONTHS_BACK = 12;

/**
 * Monthly offer prices for every city over the last year, so a transaction quarter can be matched with the
 * offer price of the same months instead of today's. A miss here only empties one column - never fail the page.
 */
export const fetchAllCitiesPricesHistory =
    (_ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
        dispatch({type: fetchReportPriceAllCitiesPricesHistoryTypes.start});

        const pricesAvailableDate = getState().report.price.pricesAvailableDate;
        const date = getPricesAvailableDate(pricesAvailableDate?.date);

        const query: IAveragePricesQuery = {
            date_start: formatISO(sub(setDate(date, 1), {months: HISTORY_MONTHS_BACK + 1}), {representation: "date"}),
            date_end: formatISO(lastDayOfMonth(sub(date, {months: 1})), {representation: "date"}),
            scenario: "rp-avg",
            offer_type: getTypeForFetch(PricesViewType.FLATS),
            slug_city: "all"
        };

        const prices = await fetchAveragePricesBySlug(query);

        dispatch({type: fetchReportPriceAllCitiesPricesHistoryTypes.success, result: prices || []});

        return prices || [];
    };
import {formatISO, lastDayOfMonth, setDate, sub} from "date-fns";
import type {Dispatch} from "redux";

import type {IFetchContext} from "@pg-mono/data-fetcher";
import {createRequestActionTypes} from "@pg-mono/request-state";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRPRequestMeta} from "../../../app/rp_request_meta";
import {getTypeForFetch, PricesViewType} from "../helpers/prices_view_type";
import type {IAveragePricesQuery} from "../types/IAveragePricesQuery";
import {getPricesAvailableDate} from "../utils/get_prices_available_date";
import {fetchAveragePricesBySlug} from "./fetch_average_prices";

const FETCH_REPORT_PRICE_ALL_CITIES_PRICES_HISTORY = "reports/FETCH_REPORT_PRICE_ALL_CITIES_PRICES_HISTORY";

export const fetchReportPriceAllCitiesPricesHistoryTypes = createRequestActionTypes(FETCH_REPORT_PRICE_ALL_CITIES_PRICES_HISTORY);

/** The oldest month the offer-price endpoint serves is 12 months before the newest complete one. */
const HISTORY_MONTHS_BACK = 12;

/**
 * Monthly offer prices for every city over the last year, so a transaction quarter can be matched with the
 * offer price of the same months instead of today's. A miss here only empties one column - never fail the page.
 */
export const fetchAllCitiesPricesHistory =
    (_ctx: IFetchContext<IRPRequestMeta, {regionSlug: string}>) => async (dispatch: Dispatch, getState: () => IRPStore) => {
        dispatch({type: fetchReportPriceAllCitiesPricesHistoryTypes.start});

        const pricesAvailableDate = getState().report.price.pricesAvailableDate;
        const date = getPricesAvailableDate(pricesAvailableDate?.date);

        const query: IAveragePricesQuery = {
            date_start: formatISO(sub(setDate(date, 1), {months: HISTORY_MONTHS_BACK + 1}), {representation: "date"}),
            date_end: formatISO(lastDayOfMonth(sub(date, {months: 1})), {representation: "date"}),
            scenario: "rp-avg",
            offer_type: getTypeForFetch(PricesViewType.FLATS),
            slug_city: "all"
        };

        const prices = await fetchAveragePricesBySlug(query);

        dispatch({type: fetchReportPriceAllCitiesPricesHistoryTypes.success, result: prices || []});

        return prices || [];
    };
